<template>
    <div>
      <Head title="Course Reports" />
      <h1 class="mb-8 text-3xl font-bold">
        Course Reports
        <downloadexcel :data="courses" :fields="course_fields">
          <v-btn large color="primary">Download <v-icon>mdi-download</v-icon></v-btn>
        </downloadexcel>
      </h1>
  
      <v-data-table :items="courses" :headers="headers">
        <template v-slot:item.course_posted_date="{ item }">
          {{ formatDate(item.course_posted_date) }}
        </template>
      </v-data-table>
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import { Link } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyAdminLayout'
  import downloadexcel from "vue-json-excel";
  
  export default {
    components: {
      Head,
      downloadexcel,
      Link
    },
    props: {
      courses: Array
    },
    data: () => ({
      headers: [
        { text: 'Course ID', value: 'course_id' },
        { text: 'Organisation', value: 'organisation' },
        { text: 'Course Title', value: 'course_title' },
        { text: 'Hits', value: 'hits' },
        { text: 'Apply Now', value: 'apply_now' },
        { text: 'User Email', value: 'user_email' },
        { text: 'User Gender', value: 'user_gender' },
        { text: 'Course Posted Date', value: 'course_posted_date' },
      ],
      course_fields: {
        "Course ID": "course_id",
        "Course Title": "course_title",
        "Hits": "hits",
        "Apply Now": "apply_now",
        "User Email": "user_email",
        "User Gender": "user_gender",
        "Organisation": "organisation",
        "Course Posted Date": "course_posted_date",
      },
    }),
    layout: Layout,
    methods: {
      formatDate(date) {
        if (!date) return '';
        return new Date(date).toLocaleDateString();
      }
    }
  }
  </script>
  
  <style scoped>
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
  </style>